module.exports = __webpack_public_path__ + "static/media/28-7.ecc440e9.mp3";